import { createRouter, createWebHistory } from 'vue-router'
import ElectronicPaymentView from '../views/ElectronicPaymentView.vue'
import NotFound from "@/components/NotFound";

const routes = [
    {
        path: '/service/electronic_payment',
        name: 'electronic_payment',
        component: ElectronicPaymentView
    },
    {
        path: '/service/hand_payment',
        name: 'hand_payment',
        component: () => import('../views/HandPaymentView.vue')
    },
    {
        path: '/service/sms_payment',
        name: 'sms_payment',
        component: () => import('../views/SmsPaymentView.vue')
    },
    {
        path: '/service/regular_payment',
        name: 'regular_paymentView',
        component: () => import('../views/RegularPaymentView.vue')
    },
    {
        path: '/404',
        name: 'notFound',
        component: NotFound
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/404",
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
